import { SVG, SVGProps } from './svg'

export function IconProfile(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 3a3 3 0 110 6 3 3 0 010-6zm0 14a7 7 0 005.6-2.8 1 1 0 000-1l-.1-.5a3 3 0 00-2.7-1.7H9.2a3 3 0 00-2.7 1.7l-.2.5a1 1 0 000 1A7 7 0 0012 19z"
      />
    </SVG>
  )
}
